<template>
    <div class="appform">
        <div class="content">
            <div style="display: flex;width: 100%;align-items: flex-start;">
                <div style="display: flex;flex: 1;align-items: flex-start;">
                    <img src="../../assets/image/logo.png" style="width: 240px;height: auto; margin-right: 32px" />
                    <img :src="createNimImgResource()" v-if="register_type == 'share'"
                        style="width: 180px;margin-top: 0px;" />
                    <img src="../../assets/image/nim_logo.png" v-else style="width: 160px;margin-top: 10px;" />
                </div>
                <div style="text-align: right;">
                    <div v-if="register_type == 'share'">
                        <p style="color: #0f448C;font-size: 28px;font-family: GravityBold">Student Registration
                            Form</p>
                            <div class="title1" style="font-size: 12px;margin-top: 5px;">please fill out this form in English</div>
                <div style="color: #ff0000; font-size: 14px; margin: 20px 0; text-align: center; width: 100%; padding: 10px; background-color: #ffe6e6; border-radius: 4px;">
                This registration form is only for STUDENTS to register for themselves. <br>If you are <strong>an ADVISOR/TEACHER</strong> registering for your school/institution, please use the<a href="/#/accountForm/nim" style="color: #ff0000; text-decoration: underline;"> Organization Registration Form</a> instead.
            </div>
                        <p style="margin-top: 10px;color: #0f448C;font-size: 18px;font-family: GravityBold"> {{
                            account_nameEN }}</p>
                    </div>
                    <p v-else style="width: 300px;font-size: 12px;text-align: right;color: #666;line-height: 20px;">
                        Extracurricular Activity Excellence (EAE) International stands as a global partner to the Next Idea Matters
                        (NIM), entrusted with the role of its operation.</p>
                </div>
            </div>
            <div class="title1" v-if="register_type == 'share'">{{ project_name }} {{projectYear}}</div>
            <el-form :model="form" :rules="formRules" ref="form" style="margin-top: 25px;">

                <div class="row single-cycle-row" v-if="register_type == 'individual'">
                    <div class="item" style="width: 100%;">
                        <el-form-item label="Registration Option" prop="nim_registration_mode" required>
                            <el-radio-group v-model="form.nim_registration_mode" style="display:flex;flex-direction:column;align-items:flex-start;gap:8px;">
                                <el-radio label="combo">NIL + 1 Track (combo)</el-radio>
                                <el-radio label="nil_only">NIL only</el-radio>
                                <el-radio label="makeup">Already have NIL — register another track</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>

                <div class="row single-cycle-row" v-if="register_type == 'individual' && form.nim_registration_mode === 'makeup'">
                    <div class="item" style="width: 100%;">
                        <el-form-item label="NIL Transcript ID" prop="nil_transcript_id" required>
                            <div style="display: flex; gap: 8px; align-items: flex-start;">
                                <el-input v-model="form.nil_transcript_id" placeholder="Application / transcript ID" style="flex: 1;"></el-input>
                                <el-button type="primary" :loading="verifyingTranscript" @click="verifyNilTranscript">Verify NIL Transcript</el-button>
                            </div>
                            <p style="color:#666;font-size:12px;margin-top:8px;line-height:16px;">Enter your NIL application ID, then verify. Use the same email as on the transcript (Email field below). Score must be ≥ 60.</p>
                            <p v-if="nilTranscriptVerified" style="color:#146C43;font-size:12px;margin-top:6px;">Transcript verified.</p>
                        </el-form-item>
                    </div>
                </div>

                <div class="row" v-if="register_type == 'individual' && form.nim_registration_mode !== 'nil_only'">
                    <div class="item">
                        <el-form-item label="Select the Idea Track" prop="project_code">
                            <el-select v-model="form.project_code" style="width: 100%;" placeholder="Please select"
                                :disabled="form.nim_registration_mode === 'makeup' && !nilTranscriptVerified">
                                <el-option v-for="(project, index) in trackProjects" :key="index"
                                    :value="project.project_code" :label="formatNimProjectOption(project)"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item" v-if="reviewCycles.length > 0">
                        <el-form-item label="Select Review Cycle" prop="application_cycle" required>
                            <el-select v-model="form.application_cycle" style="width: 100%;" placeholder="Please select"
                                :disabled="form.nim_registration_mode === 'makeup' && !nilTranscriptVerified">
                                <el-option v-for="(cycle, index) in reviewCycles" :key="index"
                                    :value="cycle.name" :label="formatCycleOptionLabel(cycle)"></el-option>
                            </el-select>
                            <div class="cycle-hint" v-if="selectedCycleFeeLines.length > 0">
                                <p v-for="line in selectedCycleFeeLines" :key="line.key">{{ line.text }}</p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item" v-else></div>
                </div>

                <div class="row" v-if="register_type == 'individual' && form.nim_registration_mode === 'nil_only'">
                    <div class="item">
                        <el-form-item label="NIL Project" prop="project_code">
                            <el-select v-model="form.project_code" style="width: 100%;" placeholder="Please select">
                                <el-option v-for="(project, index) in nilProjects" :key="index"
                                    :value="project.project_code" :label="formatNimProjectOption(project)"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item" v-if="reviewCycles.length > 0">
                        <el-form-item label="Select Review Cycle" prop="application_cycle" required>
                            <el-select v-model="form.application_cycle" style="width: 100%;" placeholder="Please select">
                                <el-option v-for="(cycle, index) in reviewCycles" :key="index"
                                    :value="cycle.name" :label="formatCycleOptionLabel(cycle)"></el-option>
                            </el-select>
                            <div class="cycle-hint" v-if="selectedCycleFeeLines.length > 0">
                                <p v-for="line in selectedCycleFeeLines" :key="line.key">{{ line.text }}</p>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row single-cycle-row" v-if="register_type == 'share' && reviewCycles.length > 0">
                    <div class="item">
                        <el-form-item label="Select Review Cycle" prop="application_cycle" required>
                            <el-select v-model="form.application_cycle" style="width: 100%;" placeholder="Please select">
                                <el-option v-for="(cycle, index) in reviewCycles" :key="index"
                                    :value="cycle.name" :label="formatCycleOptionLabel(cycle)"></el-option>
                            </el-select>
                            <div class="cycle-hint" v-if="selectedCycleFeeLines.length > 0">
                                <p v-for="line in selectedCycleFeeLines" :key="line.key">{{ line.text }}</p>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Given Name (Native Language)" prop="givenName">
                            <div class="input">
                                <el-input v-model="form.givenName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Last Name (Native Language)" prop="lastName">
                            <div class="input">
                                <el-input v-model="form.lastName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Given Name (EN)" prop="givenName_pinyin">
                            <div class="input">
                                <el-input v-model="form.givenName_pinyin" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Last Name (EN)" prop="lastName_pinyin">
                            <div class="input">
                                <el-input v-model="form.lastName_pinyin" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Email" prop="email">
                            <div class="input">
                                <el-input v-model="form.email" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="High School Graduation" prop="graduation">
                            <div class="input">
                                <el-select v-model="form.graduation" style="width: 100%;" placeholder="Please select"
                                    :popper-append-to-body="false" popper-class="customSelect">
                                    <el-option v-for="(year, index) in years" :value="year" :key="index"
                                        :label="year"></el-option>
                                </el-select>
                            </div>
                            <StudentEligibilityNotice />
                        </el-form-item>
                    </div>
                </div>

                <div class="row" v-if="register_type == 'individual'">
                    <div class="item">
                        <el-form-item prop="country">
                            <template slot="label">
                                <span>Country/Region</span>
                                <el-tooltip effect="dark" placement="top" trigger="click" content="Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.">
                                    <i class="el-icon-info" style="margin-left: 5px; color: #409EFF; cursor: pointer;"></i>
                                </el-tooltip>
                            </template>
                            <div>
                                <div class="input">
                                    <el-select v-model="form.country" style="width: 100%;" placeholder="Please select"
                                        @change="handleCountryChanged">
                                        <el-option v-for="(country, index) in countryList" :key="index"
                                            :label="country.country_en" :value="country.country_en"></el-option>
                                    </el-select>
                                </div>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.</p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Province/State" prop="province">
                            <div class="input">
                                <el-input v-model="form.province" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>



                <div class="row" style="align-items: flex-start">
                    <div class="item">
                        <el-form-item label="Guardian's Email" prop="student_guardian_first_email">
                            <div>
                                <div class="input">
                                    <el-input v-model="form.student_guardian_first_email"
                                        placeholder="Please input"></el-input>
                                </div>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">The guardian's
                                email only serves as a backup for communication if necessary.</p>

                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Advisor Name" prop="" v-if="register_type == 'share'">
                            <div>
                                <div class="input">
                                    <el-input v-model="advisor_name" :disabled="true"
                                        placeholder="Please input"></el-input>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="School Name(EN)" prop="account_id" v-else>
                            <div>
                                <div class="input" style="margin-top: 10px;">
                                    <el-select v-model="form.account_id" :multiple="false" filterable clearable="true"
                                        remote reserve-keyword placeholder="Please input keyword"
                                        :remote-method="remoteMethod" :loading="loading" loading-text="Searching schools..."
                                        no-data-text="No Result" style="width: 100%;" @change="handleAccoutChanged"
                                        @blur="handleBlurChanged">
                                        <el-option v-for="(account, index) in accounts" :key="index"
                                            :label="account.account_nameEN ? account.account_nameEN : account.account_name"
                                            :value="account._id.$id">
                                            <el-tooltip :content="account.account_nameEN ? account.account_nameEN : account.account_name" placement="top" effect="dark" :open-delay="300">
                                                <span style="float: left; max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                    {{ account.account_nameEN ? account.account_nameEN : account.account_name }}
                                                </span>
                                            </el-tooltip>
                                            <el-tag v-if="account.school_search_match_type === 'semantic'" size="mini" type="warning" effect="plain" style="float: right; margin-top: 7px;">
                                                {{ account.school_search_match_label || 'Similar match' }}
                                            </el-tag>
                                        </el-option>
                                    </el-select>
                                </div>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Please enter
                                    the school's official name with initial caps of each word. If your school does not appear in the dropdown menu, just type in the full name of your school manually.<br><br>* Select your country/region first before searching for schools.</p>
                            </div>
                        </el-form-item>
                    </div>
                    
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="School Website" prop="account_website">
                            <div class="input">
                                <el-input v-model="form.account_website" placeholder="Please input (e.g., https://www.school.edu)"></el-input>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">
                                Please provide your school's official website URL. This helps us verify your school information.
                            </p>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="School Address" prop="account_address">
                            <div class="input">
                                <el-input v-model="form.account_address" type="textarea" :rows="3" placeholder="Please input the complete school address"></el-input>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">
                                Please provide the complete address of your school including street address, city, state/province, and postal code. For home school, please leave it as N/A
                            </p>
                        </el-form-item>
                    </div>  
                </div>
                <div class="row">
                    <div class="item">
                        <!-- Left column is now empty -->
                    </div>
                    <div class="item">
                        <el-form-item label="School Annual Tuition" prop="annual_tuition">
                            <div class="input">
                                <el-select v-model="form.annual_tuition" style="width: 400px;" placeholder="Please select"  :default-first-option="true">
                                    <el-option value="11,000 USD and above">11,000 USD and above</el-option>
                                    <el-option value="6,000 - 10,999 USD">6,000 - 10,999 USD</el-option>
                                    <el-option value="3,000 - 5,999 USD">3,000 - 5,999 USD</el-option>
                                    <el-option value="1,500 - 2,999 USD">1,500 - 2,999 USD</el-option>
                                    <el-option value="1,100 - 1,499 USD">1,100 - 1,499 USD</el-option>
                                    <el-option value="750 - 1,099 USD">750 - 1,099 USD</el-option>
                                    <el-option value="350 - 749 USD">350 - 749 USD</el-option>
                                    <el-option value="1 - 349 USD">1 - 349 USD</el-option>
                                    <el-option value="Free">Free</el-option>
                                </el-select>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">
                                Please select your annual tuition fees. This information helps us determine potential fee reduction benefits. Note that you may be required to provide proof of tuition later. The selection here serves as a reference only and does not guarantee any specific fee reduction. If your tuition is paid in your local currency, please convert it to USD using the current exchange rate.<br><br>If you are receiving full or partial scholarships, please select the normal amount of tuition before the scholarship.
                            </p>
                        </el-form-item>
                    </div>
                </div>

                <!-- Add new advisor section for individual registration -->
                <template v-if="register_type == 'individual'">
                    <div class="title1" style="font-size: 18px; margin-top: 30px;">Advisor Information</div>
                    <p style="color: #666; font-size: 14px; line-height: 20px; margin-bottom: 20px; text-align: left;">
                        Per our policy, registering students must select an advisor/teacher in their schools/institutions as the advisor on the NIM program. <br>Please provide the information of your NIM Program advisor.
                        
                        
                        <br><br>
                        Having a School Advisor can be highly beneficial. The School Advisor can assist in verifying the school's information (which may involve fee reductions), help you apply for fee waivers or provide necessary documentation, connect you with more peers within the school, and gain access to additional resources. The School Advisor can also enjoy extra academic resource discounts through the school account (which is not available to independent students).
It is important to note that the School Advisor is not required to proctor the exam or be present during the competition. Advising for the NIM program will not take up a significant amount of the Advisor's time.

                        <br><br>Note: Do not provide your parent/guardian information as advisor information.
                    </p>
                    
                    <div class="row">
                        <div class="item">
                            <el-form-item label="Advisor's First Name" prop="adviser_givenName">
                                <div class="input">
                                    <el-input v-model="form.adviser_givenName" placeholder="Please input"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item label="Advisor's Last Name" prop="adviser_lastName">
                                <div class="input">
                                    <el-input v-model="form.adviser_lastName" placeholder="Please input"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row">
                        <div class="item">
                            <el-form-item label="Advisor's Position/Subject" prop="adviser_subject">
                                <div class="input">
                                    <el-input v-model="form.adviser_subject" placeholder="Please input"></el-input>
                                </div>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">*An advisor can be a subject teacher, club advisor, college & career counselor, school administrator or other school staff members who are willing to help you.</p>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item label="Advisor's Email" prop="adviser_email">
                                <div class="input">
                                    <el-input v-model="form.adviser_email" placeholder="Please input"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </template>
            </el-form>

            <div class="terms flex items-center justify-center" style="margin-top: 20px;">
                <div @click="isAgree = !isAgree" style="display: flex; align-items: center">
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isAgree"
                        :src="require('../../assets/image/unchecked.png')" />
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                        :src="require('../../assets/image/checked.png')" />
                </div>
                <p style="line-height: 20px;"> I have read and agree to the <a href="#/privacy-policy" target="_blank" rel="noopener noreferrer" style="color: #409EFF; text-decoration: underline;" @click.stop>Privacy Policy</a>, and I agree that EAE may use my provided information to set up a personal account and to email me about notifications, reminders, and extracurricular opportunities.</p>
            </div>
            <div v-if="form.project_code && !isRegistrationOpen()" style="color: #0f448C; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center; padding: 20px; background-color: #e6f0ff; border-radius: 8px; border: 2px solid #0f448C;">
                Registration is not open yet.<br>
                <span style="font-size: 14px;color: #666; display: block; margin-top: 10px;">Registration will open at {{project.start_date_string}} in your local time.</span>
                <span style="font-size: 12px;color: #999; display: block; margin-top: 8px;">Please come back later to complete your registration.</span>
            </div>
            <div v-else class="submit">
                <ApplicationConductNotice />
                <div class="submitBtn" @click="submit">Submit</div>
            </div>
        </div>
        <AccountFormConfirmDialog
            :show.sync="showConfirmDialog"
            :email="form.email"
            :highlightFields="confirmHighlightFields"
            :normalFields="confirmNormalFields"
            :requireStudentEligibilityConfirm="true"
            :themeColor="'#0f448C'"
            @confirmed="doSubmit"
        />
    </div>
</template>
<script>
import {
    createNimStudentRegistration,
    validateNilTranscriptForMakeup,
    getContactInfo,
    getProjectInfoByCode,
    getProjectManageByCode,
    getCountries,
    getNIMProjects,
    getExclusivePartners
} from '../../api/eae'
import { exclusivePartnersMixin } from '../../utils/exclusivePartners'
import AccountFormConfirmDialog from '../../components/AccountFormConfirmDialog.vue'
import ApplicationConductNotice from '../../components/ApplicationConductNotice.vue'
import StudentEligibilityNotice from '../../components/StudentEligibilityNotice.vue'
import { checkAndConfirmName } from '../../utils/nameValidator'
import { searchSchoolOptions } from '../../utils/schoolSearch'
import { confirmAdvisorSchoolMatch } from '../../utils/advisorSchoolMatch'
import { showSuspiciousApplicationNotice } from '../../utils/suspiciousApplicationNotice'
import {
    buildReviewCycleFeeLines,
    buildComboCycleCopyLines,
    buildReviewCycleOptionLabel,
    getReviewCycleDisplayName,
    isCurrentReviewCycle,
    shouldShowReviewCycle
} from '../../utils/nimReviewCycles'
import '../../assets/common/font.css'
export default ({
    name: 'index',
    components: { AccountFormConfirmDialog, ApplicationConductNotice, StudentEligibilityNotice },
    mixins: [exclusivePartnersMixin],
    data() {
        return {
            projects: [],
            accounts: [],
            project_code: this.$route.query.project_code,
            contact_id: this.$route.query.contact_id,
            isAgree: false,
            loading: false,
            years: [],
            form: {
                project_code: '',
                contact_id: '',
                account_id: '',
                lastName: '',
                givenName: '',
                lastName_pinyin: '',
                givenName_pinyin: '',
                graduation: '',
                email: '',
                student_guardian_first_email: '',
                adviser_givenName: '',
                adviser_lastName: '',
                adviser_subject: '',
                adviser_email: '',
                annual_tuition: '',
                account_website: '',
                account_address: '',
                application_cycle: '',
                nim_registration_mode: 'combo',
                nil_transcript_id: '',
            },
            rawReviewCycles: [],
            nilTranscriptVerified: false,
            verifyingTranscript: false,
            formRules: {
                nim_registration_mode: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                project_code: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                application_cycle: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                nil_transcript_id: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.nim_registration_mode === 'makeup' && !value) {
                                callback(new Error('Please input'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                givenName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                lastName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                account_nameEN: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                province: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                country: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                lastName_pinyin: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                givenName_pinyin: [
                    { required: true, message: "Please choose", trigger: "change" },
                ],
                graduation: [
                    { required: true, message: "Please choose", trigger: "change" },
                ],
                account_id: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                email: [
                    { required: true, message: "Please input", trigger: "change" },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                adviser_givenName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                adviser_lastName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                adviser_subject: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                adviser_email: [
                    { required: true, message: "Please input", trigger: "change" },
                    { type: 'email', message: 'Please input correct email address', trigger: 'change' }
                ],
                annual_tuition: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                account_website: [
                    { required: true, message: "Please input school website", trigger: "change" },
                    { 
                        min:10,
                        message: "Please enter a valid website URL", 
                        trigger: "change" 
                    }
                ],
                account_address: [
                    { required: true, message: "Please input school address", trigger: "change" },
                    { min: 10, message: "School address should be at least 10 characters", trigger: "change" }
                ],
                student_guardian_first_email: [
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ]
            },
            account_nameEN: '',
            advisor_name: '',
            project_name: '',
            project: {},

            register_type: 'individual',

            countryList: [],
            selectCountryEn: '',
            showConfirmDialog: false

        }
    },
    watch: {
        'form.project_code'(newVal) {
            if (newVal) {
                this.form.application_cycle = ''
                this.getProjectInfo()
                this.loadReviewCycles(newVal)
            } else {
                this.rawReviewCycles = []
                this.form.application_cycle = ''
            }
        },
        'form.nil_transcript_id'() {
            this.nilTranscriptVerified = false
        },
        'form.nim_registration_mode'(newVal) {
            this.form.application_cycle = ''
            this.form.nil_transcript_id = ''
            this.nilTranscriptVerified = false
            if (newVal === 'nil_only') {
                const nil = this.nilProjects[0]
                this.form.project_code = nil ? nil.project_code : ''
            } else if (this.form.project_code && /NIL$/i.test(this.form.project_code)) {
                this.form.project_code = ''
            }
        }
    },
    computed: {
        trackProjects() {
            return (this.projects || []).filter(p => p && p.project_code && !/NIL$/i.test(p.project_code))
        },
        nilProjects() {
            return (this.projects || []).filter(p => p && p.project_code && /NIL$/i.test(p.project_code))
        },
        reviewCycles() {
            return this.rawReviewCycles.filter(cycle => shouldShowReviewCycle(cycle))
        },
        selectedCycle() {
            return this.reviewCycles.find(cycle => cycle.name === this.form.application_cycle) || null
        },
        selectedCycleFeeLines() {
            if (this.form.nim_registration_mode === 'combo') {
                return buildComboCycleCopyLines(this.selectedCycle, this.project, this.companionNilProject, this.formatCycleDate, {
                    entryDates: this.rawReviewCycles
                })
            }
            return buildReviewCycleFeeLines(this.selectedCycle, this.project, this.formatCycleDate, {
                entryDates: this.rawReviewCycles,
                isMakeup: this.form.nim_registration_mode === 'makeup'
            })
        },
        selectedCycleDisplayName() {
            return getReviewCycleDisplayName(this.selectedCycle || this.form.application_cycle)
        },
        selectedCycleIsCurrent() {
            return isCurrentReviewCycle(this.selectedCycle, this.rawReviewCycles)
        },
        companionNilProject() {
            const trackCode = String(this.form.project_code || '')
            const year = (trackCode.match(/^(\d{4})/) || [])[1]
            if (year) {
                const sameYear = this.nilProjects.find(p => String(p.project_code || '').toUpperCase() === `${year}NIL`)
                if (sameYear) return sameYear
            }
            return this.nilProjects[0] || null
        },
        projectYear() {
            // Extract year from project_code (e.g., "2025NSI" -> 2025)
            const projectCode = this.form.project_code || this.project_code || ''
            const yearMatch = projectCode.match(/^(\d{4})/)
            if (yearMatch) {
                return yearMatch[1]
            }
            // Fallback to current year calculation
            const now = new Date()
            const currentYear = now.getFullYear()
            const currentMonth = now.getMonth() + 1
            if (currentMonth >= 10) {
                return currentYear + 1
            } else {
                return currentYear
            }
        },
        confirmHighlightFields() {
            const modeLabel = {
                combo: 'NIL + Track (combo)',
                nil_only: 'NIL only',
                makeup: 'Track with existing NIL'
            }[this.form.nim_registration_mode] || this.form.nim_registration_mode
            return [
                { label: 'Name', value: (this.form.givenName_pinyin + ' ' + this.form.lastName_pinyin).trim() },
                { label: 'Email', value: this.form.email },
                { label: 'Country/Region', value: this.form.country },
                { label: 'Registration Option', value: modeLabel },
                { label: 'Review Cycle', value: this.selectedCycleDisplayName },
                { label: 'Window', value: this.form.nim_registration_mode === 'makeup' ? 'Makeup (early-bird slot)' : (this.selectedCycleIsCurrent ? 'Current (accelerated)' : 'Later (standard)') }
            ].filter(f => f.value)
        },
        confirmNormalFields() {
            return [
                { label: 'School/Organization', value: this.form.account_nameEN },
                { label: 'Graduation Year', value: this.form.graduation },
                { label: 'Province', value: this.form.province },
            ].filter(f => f.value)
        }
    },
    mounted() {
        // this.contact_id = '60ac90b6a4640ba65a8b4570'
        //         2025NSI
        // 2025NRI
        // 2025NIR
        // 2025NIP
        // 2025NIA
        // 2025NIE
        // 2025NII
        // 2025NIV
        // this.project_code = '2025NIV'
        this.form.project_code = this.project_code
        this.form.contact_id = this.contact_id
        let current_year = new Date().getFullYear()
        let start_year = current_year +1
        for (let i = 0; i < 5; i++) {
            let year = start_year + i
            this.years.push(year)
        }

        if (this.contact_id && this.project_code) {//是通过注册链接打开的
            this.register_type = 'share'
            this.requestContactInfo()
            this.requestProjectInfo()
            this.fetchExclusivePartners(this.project_code)
        } else { //学生个人注册报名
            this.requestCountryList()
            this.requestNIMProjects()
            this.fetchExclusivePartners()
            // If project_code is set from route, get project info
            if (this.form.project_code) {
                this.getProjectInfo()
            }
        }
    },
    methods: {

        requestNIMProjects() {
            getNIMProjects().then((res) => {
                this.projects = Array.isArray(res.data) ? res.data : []
            })
        },

        formatNimProjectOption(project) {
            if (!project) return ''
            const code = String(project.project_code || '')
            const name = project.project_ename || code
            const yearMatch = code.match(/^(\d{4})/)
            const years = new Set(
                (this.projects || [])
                    .map(p => String((p && p.project_code) || '').slice(0, 4))
                    .filter(y => /^\d{4}$/.test(y))
            )
            if (years.size > 1 && yearMatch) {
                return `${yearMatch[1]} · ${name}`
            }
            return name
        },

        handleCountryChanged(e) {
            for (let i = 0; i < this.countryList.length; i++) {
                if (this.countryList[i].country_en == this.form.country) {
                    this.selectCountryEn = this.countryList[i].country_en
                    break
                }
            }
            this.checkExclusivePartner(this.form.country)
        },

        fetchExclusivePartners(projectCode) {
            if (!projectCode) {
                const dynamicCode = this.form.project_code || this.project_code
                if (dynamicCode) {
                    this.fetchExclusivePartners(dynamicCode)
                }
                return
            }
            getExclusivePartners(projectCode).then((res) => {
                if (res.data.code === 0) {
                    this.exclusivePartners = res.data.data || []
                }
            }).catch(err => {
                console.error('Failed to fetch exclusive partners:', err)
            })
        },

        requestCountryList() {
            getCountries().then((res) => {
                this.countryList = res.data
            })
        },

        handleBlurChanged(e) {
            let that = this
            setTimeout(() => {
                if (!that.form.account_id || that.accounts.length <= 0) {
                    that.form.account_id = that.form.account_nameEN
                }
            }, 100)
        },

        handleAccoutChanged(e) {
            for (let i = 0; i < this.accounts.length; i++) {
                let account = this.accounts[i]
                if (account._id.$id == this.form.account_id) {
                    this.form.account_nameEN = account.account_nameEN ? account.account_nameEN : account.account_name
                    break
                }
            }
        },

        remoteMethod(keyword) {
            searchSchoolOptions(this, {
                keyword,
                country: this.selectCountryEn,
                setKeyword: value => {
                    this.form.account_nameEN = value
                },
                setAccounts: accounts => {
                    this.accounts = accounts
                }
            })
        },


        createNimImgResource() {
            let project_code = this.project_code
            if (project_code == '2026NSI') {
                return require('../../assets/image/nsi_logo.png')
            }
            if (project_code == '2026NRI') {
                return require('../../assets/image/nri_logo.png')
            }
            if (project_code == '2026NIR') {
                return require('../../assets/image/nir_logo.png')
            }
            if (project_code == '2026NIP') {
                return require('../../assets/image/nip_logo.png')
            }
            if (project_code == '2026NIA') {
                return require('../../assets/image/nia_logo.png')
            }
            if (project_code == '2026NIE') {
                return require('../../assets/image/nie_logo.png')
            }
            if (project_code == '2026NII') {
                return require('../../assets/image/nii_logo.png')
            }
            if (project_code == '2026NIV') {
                return require('../../assets/image/niv_logo.png')
            }
        },


        requestContactInfo() {
            getContactInfo(this.contact_id).then((res) => {
                let result = res.data.data
                this.form.account_id = result.account_id
                this.advisor_name = result.contact_enName
                this.account_nameEN = result.account.account_nameEN
            })
        },

        requestProjectInfo() {
            getProjectInfoByCode(this.project_code).then((res) => {
                this.project_name = res.data.project_ename
                this.getProjectInfo()
                this.loadReviewCycles(this.project_code)
            })
        },
        loadReviewCycles(projectCode) {
            if (!projectCode) {
                this.rawReviewCycles = []
                return
            }
            getProjectManageByCode(projectCode).then((res) => {
                const manage = res.data || {}
                const entries = Array.isArray(manage.entry_date) ? manage.entry_date : []
                this.rawReviewCycles = entries.filter(cycle => cycle && cycle.name)
                if (this.reviewCycles.length === 0) {
                    this.form.application_cycle = ''
                } else if (this.form.application_cycle && !this.selectedCycle) {
                    this.form.application_cycle = ''
                }
            }).catch(() => {
                this.rawReviewCycles = []
            })
        },
        formatCycleOptionLabel(cycle) {
            return buildReviewCycleOptionLabel(cycle, this.formatCycleDate)
        },
        formatCycleDate(value) {
            const ts = typeof value === 'number' ? value : Date.parse(value)
            if (!ts || Number.isNaN(ts)) return ''
            return new Date(ts).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            })
        },
        getProjectInfo() {
            const projectCode = this.form.project_code || this.project_code
            if (!projectCode) return
            
            getProjectInfoByCode(projectCode).then((res) => {
                this.project = res.data
                
                // Process start date for registration opening check
                if (this.project.project_progress_start_date) {
                    let startDate = new Date(this.project.project_progress_start_date)
                    // Get the date components in local timezone
                    let year = startDate.getFullYear()
                    let month = startDate.getMonth()
                    let day = startDate.getDate()
                    // Create new date at 00:00:00 in local timezone
                    let localStartDate = new Date(year, month, day, 0, 0, 0, 0)
                    // Format as string in local timezone
                    this.project.start_date_string = localStartDate.toLocaleString('en-US', { 
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                    })
                    this.project.start_date = localStartDate.getTime()
                }
            }).catch(err => {
                console.error('Failed to get project info:', err)
            })
        },
        isRegistrationOpen() {
            if (!this.project.start_date) {
                return true; // If no start date, assume registration is open
            }
            const currentTime = new Date().getTime();
            return currentTime >= this.project.start_date;
        },
        verifyNilTranscript() {
            const transcriptId = (this.form.nil_transcript_id || '').trim()
            const email = (this.form.email || '').trim()
            if (!transcriptId) {
                this.$message.warning('Please enter your NIL Transcript ID.')
                return
            }
            if (!email) {
                this.$message.warning('Please enter your email (same as the NIL transcript) before verifying.')
                return
            }
            this.verifyingTranscript = true
            validateNilTranscriptForMakeup(email, transcriptId).then((res) => {
                const result = res && res.data ? res.data : {}
                if (result.code === 0) {
                    this.nilTranscriptVerified = true
                    this.$message.success('NIL transcript verified.')
                } else {
                    this.nilTranscriptVerified = false
                    this.$message.error(result.msg || 'Transcript verification failed.')
                }
            }).catch(() => {
                this.nilTranscriptVerified = false
                this.$message.error('Transcript verification failed. Please try again.')
            }).finally(() => {
                this.verifyingTranscript = false
            })
        },
        submit() {
            if (this.form.nim_registration_mode === 'makeup' && !this.nilTranscriptVerified) {
                this.$message.warning('Please verify your NIL transcript before selecting a track and submitting.')
                return
            }
            if (!this.validateExclusivePartnerBeforeSubmit(this.form.country)) {
                return
            }

            if (!this.isAgree) {
                this.$message.warning("You must agree to the statement.");
                return;
            }

            // Check if registration is open
            if (this.form.project_code && !this.isRegistrationOpen()) {
                this.$message.warning("Registration is not open yet. Please come back later.");
                return;
            }

            if (this.reviewCycles.length > 0 && !this.selectedCycle) {
                this.$message.warning("Please select a review cycle.");
                return;
            }

            this.$refs.form.validate((val) => {
                if (val) {
                    checkAndConfirmName(this, [
                        { first: this.form.givenName_pinyin, last: this.form.lastName_pinyin, label: 'Name (EN)' },
                        { first: this.form.givenName, last: this.form.lastName, label: 'Name (Native Language)' }
                    ]).then(() => {
                        return confirmAdvisorSchoolMatch(this)
                    }).then((confirmed) => {
                        if (confirmed) {
                            this.showConfirmDialog = true
                        }
                    }).catch(() => {})
                }
            });
        },
        doSubmit() {
            if (this.register_type == 'share') {
                // Advisor share: map fixed project into NIM modes
                const isNil = /NIL$/i.test(this.form.project_code || this.project_code || '')
                const payload = {
                    ...this.form,
                    project_code: this.form.project_code || this.project_code,
                    nim_registration_mode: isNil ? 'nil_only' : 'combo'
                }
                createNimStudentRegistration(payload).then((res) => {
                    const data = res.data && res.data.data ? res.data.data : res.data
                    if (res.data && res.data.code < 0) {
                        this.$message.error(res.data.msg || 'Registration failed')
                        return
                    }
                    const id = data && data._id ? (data._id.$id || data._id) : ''
                    const goToSuccess = () => {
                        this.$router.replace({
                            path: '/form/success',
                            query: {
                                id,
                                project: this.project_code
                            }
                        })
                    }
                    if (data && data.suspicious_application === true) {
                        showSuspiciousApplicationNotice(this).then(goToSuccess).catch(goToSuccess)
                    } else {
                        goToSuccess()
                    }
                });
                return
            }
            if (this.form.account_id == this.form.account_nameEN) {
                this.form.account_id = ''
            }
            const loading = this.$loading({
                    lock: true,
                    text: 'Submitting registration...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            createNimStudentRegistration(this.form).then((res) => {
                loading.close();
                if (res.data && res.data.code === 0) {
                    const app = res.data.data
                    const appId = app && app._id ? (app._id.$id || app._id) : ''
                    const go = () => {
                        this.$router.replace({
                            path: '/form/success',
                            query: {
                                id: appId,
                                project: 'NIM'
                            }
                        });
                    }
                    if (app && app.suspicious_application === true) {
                        showSuspiciousApplicationNotice(this).then(go).catch(go)
                    } else {
                        go()
                    }
                } else {
                    this.$message.error((res.data && res.data.msg) || 'Registration failed');
                }
            }).catch((err) => {
                loading.close();
                console.error('Registration error:', err);
                const errorMsg = err.response?.data?.msg || err.response?.data?.message || err.message || 'Registration failed. Please try again or contact support.';
                this.$message.error({
                    message: errorMsg,
                    duration: 8000
                });
            });
        },
    }
})
</script>
<style scoped lang="scss">
::-webkit-scrollbar {
    display: none;
}

.appform {
    font-family: GravityNormal;
    width: 100vw;
    height: 100vh;
    background-color: #0f448C;

    .content {
        overflow-y: auto;
        width: 1000px;
        height: 100vh;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 30px 40px 20px;
        background: #fff;
        position: relative;

        .title1 {
            margin-top: 30px;
            font-family: GravityBold;
            color: #0f448C;
            font-size: 22px;
            margin-bottom: 50px;
            align-items: center;
            width: 100%;
            font-weight: bold;
            text-align: center;
        }

        .row {
            display: flex;
            justify-content: space-between;

            .item {
                width: 420px;

                .label {
                    font-size: 16px;
                    font-family: GravityNormal;
                    font-weight: normal;
                    color: #666666;
                }

                .input {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    font-size: 18px;

                    font-family: GravityNormal;
                    font-weight: normal;
                    color: #333333;

                    img {
                        margin-right: 24px;
                        cursor: pointer;
                    }
                }
            }
        }

        .single-cycle-row {
            justify-content: flex-start;
        }

        .cycle-hint {
            color: #666;
            font-size: 12px;
            line-height: 16px;
            margin-top: 10px;

            p {
                margin: 0 0 4px;
            }
        }
    }

    .submit {
        .submitBtn {
            font-family: GravityBold;
            width: 280px;
            height: 50px;
            background: #0f448C;
            border-radius: 25px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            margin: 0 auto;
            margin-top: 20px;
            cursor: pointer;
        }

        margin-bottom: 50px;
    }
}
</style>
<style lang="scss">
.appform {
    .el-input__inner {
        border-radius: 6px;
        border-color: #0f448C;
        font-family: GravityNormal;
        // border: 2px solid #717171;
        // font-size: 18px;
    }

    .el-form-item__label {
        font-family: GravityNormal;
    }
}

.successConfirm {
    width: 470px;

    .el-message-box__status.el-icon-success {
        top: 11% !important;
    }
}
</style>
